import {NgModule} from '@angular/core';
import {Route, RouterModule} from '@angular/router';
import {LenderDelayedLoansComponent} from './lender-delayed-loans.component';

const routes: Route[] = [{
    path: '',
    component: LenderDelayedLoansComponent
}];

@NgModule({
    imports: [RouterModule.forChild(routes)]
})
export class LenderDelayedLoansRoutingModule {
}
